// @flow

export type Data = { date: Date, keys: string[], values: number[] };

export const HEIGHT: number = 437;
export const PADDING: number = 10;
export const X_OFFSET: number = 25;
export const Y_OFFSET: number = 25;
